import { createReducer } from '@common/utils/redux';
import { ORDERS_PATIENTS_ACTION_TYPES } from '../const/patients';

const initialState = {
    list: [],
    listFilters: {},
    listCount: 0,
};

export default createReducer(
    initialState,
    {
        [ORDERS_PATIENTS_ACTION_TYPES.setList]: (state, list) => ({
            ...state,
            list,
        }),
        [ORDERS_PATIENTS_ACTION_TYPES.setListCount]: (state, listCount) => ({
            ...state,
            listCount,
        }),
        [ORDERS_PATIENTS_ACTION_TYPES.setFilters]: (state, listFilters) => ({
            ...state,
            listFilters,
        })
    },
);